<template>
    <div class="form-group">
        <label>
            <span>{{ label }}</span>
            <textarea class="input__field" v-bind:rows="rows" v-bind:maxlength="maxLength" v-bind:name="name" v-model="internalValue" style="border: 0"></textarea>
        </label>
        <span class="f-s-1 fr c-medium-tint">{{ textLength }}/{{ maxLength }}</span>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String
        },
        name: {
            type: String
        },
        rows: {
            type: Number
        },
        maxLength: {
            type: Number
        },
        value: {
            type: String
        }
    },
    computed: {
        textLength() {
            return this.internalValue.length;
        }
    },
    data() {
        return {
            internalValue: this.value || '',
        }
    },
}
</script>
